import { Plan } from './Plan';
import { Minimap } from './Minimap';

export default class Panorama {
  constructor(data = {}) {
    const { plans = [], minimaps = [] } = data;

    Object.assign(this, {
      plans: plans.map((plan) => new Plan(plan)),
      minimaps: minimaps.map((minimap) => new Minimap(minimap)),
    });
  }
}
